var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-text",
                {
                  staticClass: "app-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.$ct("views")) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "w100" },
        [
          _vm.$wf.isMdUp
            ? _c("w-breadcrumb", { attrs: { crumbs: _vm.path } })
            : _vm._e(),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-view-list", {
                        attrs: { views: _vm.views, title: _vm.title },
                        on: {
                          "new-clicked": function ($event) {
                            return _vm.createNewView()
                          },
                          "edit-clicked": function ($event) {
                            return _vm.editClicked($event)
                          },
                          "delete-clicked": function ($event) {
                            return _vm.deleteView($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }